/* eslint-disable */
import React from 'react';
import { Line } from 'react-chartjs-2';

const GraphicMultiLine = (props) => {
  const { grapichData, isStatusDate } = props;
 
  const { innerWidth: width } = window;
  const options = {
    plugins: {
      tooltip: {
        enabled: true,
      },
    },
    maintainAspectRatio:false,
    legend: {
      display: false
    },
    // scales: {
    //   y: {
    //     beginAtZero: true,
    //   },
    // },
      scales: {
        xAxes: [{
          gridLines: { display: true }
        }], 
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
      ],
    },
    tooltips:{
      custom: function(tooltip) {
        if (!tooltip) return;
        // disable displaying the color box;
        tooltip.displayColors = false;
      },
      // callbacks:{
      //   label: function(tooltipItem, data) {
      //     console.log('data tooltipItem', tooltipItem,data)
      //     if(isStatusDate){
      //       var xdata = parseInt(tooltipItem.label);
      //       let dataDate = xdata < 10 ? 0 + '' + xdata : xdata
      //       let xstatus = tooltipItem?.label.includes('AM') ? 'AM' : 'PM'
      //       console.log('tooltip', tooltipItem.label + ' - ' + dataDate  + ':' + 59 + ' ' + xstatus)
      //       return `Range date : ${tooltipItem.label + ' - ' + dataDate + ':' + 59 + ' ' + xstatus} | Total : ${tooltipItem?.yLabel}`;
      //     }
      //   },
      // }
    }
  
  };

  if(isStatusDate){
   options.tooltips.callbacks = {
      label: function(tooltipItem, data) {
        var xdata = parseInt(tooltipItem.label);
        let dataDate = xdata < 10 ? 0 + '' + xdata : xdata
        let xstatus = tooltipItem?.label.includes('AM') ? 'AM' : 'PM'
        return `Range : ${tooltipItem.label + ' - ' + dataDate + ':' + 59 + ' ' + xstatus}`;
      },
      // footer: function(tooltipItem, data) {
      //   let dataIndex = tooltipItem[0].datasetIndex === 1 ? 'Total Failed' : 'Total Success'
      //   return `${dataIndex} : ${tooltipItem[0]?.yLabel}`;
      // },
    }
  }else{
    options.tooltips.callbacks = {
      // label: function(tooltipItem, data) {
      //   let dataIndex = tooltipItem.datasetIndex === 1 ? 'Total Failed' : 'Total Success'
      //   return `${dataIndex} : ${tooltipItem?.yLabel}`;
      // },
      footer: function(tooltipItem, data) {
        return
      },
    }
  }
 
  // {
  //   plugins:{
  //     tooltips:{
  //       enabled:true
  //     }
  //   },
  //   title: true,
  //   legend: {
  //     display: true
  //   },
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   tooltips: true,
  //   layout: {
  //     padding: {
  //       right: 40,
  //       left: 20
  //     }
  //   },
  //   elements: {
  //     point: {
  //       radius: 0
  //     }
  //   },
  //   scales: {
  //     xAxes: [{
  //       gridLines: { display: false }
  //     }], yAxes: [
  //       {
  //         ticks: {
  //           beginAtZero: true,
  //         },
  //       },
  //     ],

  //   }
  // }
  return (
    <>
      <Line
        data={grapichData}
        width={width > 1024 ? 635 : (width - 80)}
        height={width > 1024 ? 330 : (width / 2)}
        options={options}
      />
    </>
  )
}

export default GraphicMultiLine